import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import Button from 'components/Button';
import i18n from 'i18n';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface DialogAlertProps {
  icon?: React.ReactNode;
  title: string | React.ReactElement;
  content: string | React.ReactNode;
  labelCancel?: string;
  labelConfirm?: string;
  small?: boolean;
  alignActionButtons?: string;
  onClose?: () => void;
  onConfirm?: () => void;
}

export const DialogAlertInitial = {
  title: '',
  content: '',
};

const DialogAlert = ({
  icon,
  title,
  content,
  labelCancel,
  labelConfirm,
  small,
  alignActionButtons = '',
  onConfirm,
  onClose,
}: DialogAlertProps) => {
  const classes = useStyles();

  return (
    <Dialog
      className={clsx(classes.root, {
        [classes.small]: small,
      })}
      open={!!title}
      onClose={onClose}
      data-testid={'autosky-dialogalert'}
    >
      {!!icon && <div className={classes.icon}>{icon}</div>}
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes[alignActionButtons]}>
        {onClose && (
          <Button id="cancel-dialog" onClick={onClose}>
            {labelCancel || i18n.t('CANCEL_KEY')}
          </Button>
        )}
        {onConfirm && (
          <Button id="confirm-dialog" onClick={onConfirm}>
            {labelConfirm || i18n.t('CONFIRM_KEY')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogAlert;
